import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories } from '@/mocks/categories';
import { getHotArticles, getLatestArticles, articles } from '@/mocks/articles';

function HeroSection() {
  const featured = articles.find((a) => a.isHot && a.isExclusive) || articles[0];

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20cityscape%20at%20night%20with%20neon%20red%20and%20amber%20accents%2C%20moody%20atmosphere%2C%20mysterious%20urban%20scene%2C%20film%20noir%20aesthetic%2C%20rain%20on%20pavement%2C%20distant%20city%20lights%2C%20cinematic%20wide%20shot%2C%20high%20contrast%2C%20dark%20and%20brooding%20tone&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="黑料社背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <p className="inline-block text-sm text-accent-300 bg-accent-900/60 px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
            <i className="ri-fire-line mr-1"></i> 最新独家爆料 · 实时追踪
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-tight">
            第一时间掌握
            <br />
            <span className="text-primary-400">娱乐圈不为人知的真相</span>
          </h1>
          <p className="text-base md:text-lg text-white/70 mb-8 max-w-2xl mx-auto">
            黑料社聚合全网最新明星黑料、网红爆料、娱乐圈内幕，海量独家资讯持续更新中
          </p>

          <Link
            to={`/article/${featured.id}`}
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-flashlight-line"></i>
            查看今日重磅爆料
          </Link>

          <div className="flex items-center justify-center gap-6 mt-8 text-white/50 text-sm flex-wrap">
            <span className="flex items-center gap-1">
              <i className="ri-article-line"></i> {articles.length}+ 独家爆料
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i> 日均 100万+ 阅读
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i> 24小时持续更新
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

function TrendingNews() {
  const hotArticles = getHotArticles();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-fire-line text-accent-600 text-lg"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
              热门爆料
            </h2>
            <p className="text-sm text-foreground-400">全网最火的黑料都在这里</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestArticles() {
  const latestArticles = getLatestArticles(8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-timer-flash-line text-primary-600 text-lg"></i>
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                最新爆料
              </h2>
              <p className="text-sm text-foreground-400">实时更新的独家资讯</p>
            </div>
          </div>
          <Link
            to="/category/mingxing-heiliao"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}

function HotCategories() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-grid-line text-secondary-600 text-lg"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
              热门分类
            </h2>
            <p className="text-sm text-foreground-400">按兴趣浏览不同领域的爆料</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-center"
            >
              <div className={`w-12 h-12 mx-auto rounded-full ${cat.color} bg-opacity-10 flex items-center justify-center mb-3`}>
                <i className={`${cat.icon} text-lg ${cat.color.replace('bg-', 'text-')}`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400">{cat.articleCount} 篇爆料</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20pattern%20with%20red%20and%20amber%20accents%2C%20subtle%20texture%2C%20moody%20atmosphere%2C%20modern%20design%2C%20dark%20background%20with%20warm%20highlights&width=1920&height=400&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-background-900/90"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
          不错过任何一条猛料
        </h2>
        <p className="text-white/60 text-sm mb-6">
          订阅黑料社，第一时间收到最新爆料推送
        </p>
        <form
          data-readdy-form=""
          action="https://readdy.ai/api/form/d9qruree3oq4jqumtprg"
          method="POST"
          className="flex flex-col sm:flex-row gap-3 justify-center"
        >
          <input
            type="email"
            name="email"
            placeholder="输入您的邮箱地址"
            required
            className="px-5 py-3 rounded-full text-sm bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-primary-400 flex-1 max-w-md"
          />
          <input
            type="text"
            name="phone_alt"
            autoComplete="off"
            tabIndex={-1}
            aria-hidden="true"
            readOnly
            className="form-honeypot"
          />
          <button
            type="submit"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即订阅
          </button>
        </form>
      </div>
    </section>
  );
}

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料社',
    url: 'https://heiliao.com',
    description: '黑料社是专注于独家爆料、明星黑料、娱乐圈内幕的聚合资讯平台。第一时间获取最新黑料动态，深度揭秘娱乐圈不为人知的真相。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliao.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料社',
    url: 'https://heiliao.com',
    description: '专注独家黑料爆料的聚合资讯平台',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <TrendingNews />
        <LatestArticles />
        <HotCategories />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}